import { render, staticRenderFns } from "./cSticky.vue?vue&type=template&id=6f4dc9bc&scoped=true"
import script from "./cSticky.vue?vue&type=script&lang=js"
export * from "./cSticky.vue?vue&type=script&lang=js"
import style0 from "./cSticky.vue?vue&type=style&index=0&id=6f4dc9bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4dc9bc",
  null
  
)

export default component.exports